var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { width: "100%" } },
    [
      _vm.generalPurposeCard
        ? _c("div", { staticClass: "rcs-message-container" }, [
            _c("div", { class: _vm.layoutClass, style: _vm.messageStyle }, [
              RegExp(/image\/*/).test(_vm.mediaContentType)
                ? _c("img", {
                    class:
                      _vm.title ||
                      _vm.description ||
                      (_vm.links && _vm.links.length > 0)
                        ? "rcs-image"
                        : "rcs-radius-image",
                    attrs: { src: _vm.mediaUrl || _vm.thumbnailUrl }
                  })
                : _vm._e(),
              _vm._v(" "),
              RegExp(/video\/*/).test(_vm.mediaContentType)
                ? _c(
                    "video",
                    {
                      class:
                        _vm.title ||
                        _vm.description ||
                        (_vm.links && _vm.links.length > 0)
                          ? "rcs-image"
                          : "rcs-radius-image",
                      style: { height: _vm.mediaHeight, objectFit: "contain" },
                      attrs: { controls: "", poster: _vm.thumbnailUrl }
                    },
                    [
                      _c("source", {
                        attrs: { src: _vm.mediaUrl, type: _vm.mediaContentType }
                      }),
                      _vm._v(
                        _vm._s(
                          _vm.formatMessage({
                            id: "5g.message.h5.tipmsg.msg1",
                            defaultMessage: "您的浏览器不支持 HTML5 video 标签"
                          })
                        ) + "\n        "
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              RegExp(/audio\/*/).test(_vm.mediaContentType)
                ? _c(
                    "video",
                    {
                      class:
                        _vm.title ||
                        _vm.description ||
                        (_vm.links && _vm.links.length > 0)
                          ? "rcs-image"
                          : "rcs-radius-image",
                      style: { height: _vm.mediaHeight, objectFit: "contain" },
                      attrs: { controls: "", poster: _vm.thumbnailUrl }
                    },
                    [
                      _c("source", {
                        attrs: { src: _vm.mediaUrl, type: _vm.mediaContentType }
                      }),
                      _vm._v(
                        _vm._s(
                          _vm.formatMessage({
                            id: "5g.message.h5.tipmsg.msg1",
                            defaultMessage: "您的浏览器不支持 HTML5 video 标签"
                          })
                        ) + "\n        "
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "rcs-content-con" },
                [
                  _vm.title
                    ? _c(
                        "div",
                        { staticClass: "rcs-title", style: _vm.titleStyle },
                        [_vm._v(_vm._s(_vm.title))]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.description
                    ? _c(
                        "div",
                        {
                          staticClass: "rcs-description",
                          style: _vm.descriptionStyle
                        },
                        [_vm._v(_vm._s(_vm.description))]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._l(_vm.links, function(link) {
                    return _c("div", [
                      link.reply
                        ? _c(
                            "a",
                            {
                              staticClass: "rcs-link",
                              style: _vm.linksStyle,
                              on: {
                                click: function($event) {
                                  return _vm.handleLinkClick(link)
                                }
                              }
                            },
                            [_vm._v(_vm._s(link.reply.displayText))]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      link.action
                        ? _c(
                            "a",
                            {
                              staticClass: "rcs-link",
                              style: _vm.linksStyle,
                              on: {
                                click: function($event) {
                                  return _vm.handleLinkClick(link)
                                }
                              }
                            },
                            [_vm._v(_vm._s(link.action.displayText))]
                          )
                        : _vm._e()
                    ])
                  })
                ],
                2
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.generalPurposeCardCarousel
        ? _c(
            "div",
            { staticClass: "con" },
            _vm._l(_vm.contentList, function(content, index) {
              return _c(
                "div",
                {
                  key: index,
                  staticClass: "generalPurposeCardCarousel",
                  style: _vm.messageStyle
                },
                [
                  RegExp(/image\/*/).test(content.mediaContentType)
                    ? _c("img", {
                        class: _vm.getImageClass(content),
                        style: { height: content.mediaHeight },
                        attrs: { src: content.mediaUrl || content.thumbnailUrl }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  RegExp(/video\/*/).test(content.mediaContentType)
                    ? _c(
                        "video",
                        {
                          class: _vm.getImageClass(content),
                          style: {
                            height: content.mediaHeight,
                            objectFit: "contain"
                          },
                          attrs: { controls: "", poster: content.thumbnailUrl }
                        },
                        [
                          _c("source", {
                            attrs: {
                              src: content.mediaUrl,
                              type: content.mediaContentType
                            }
                          }),
                          _vm._v(
                            _vm._s(
                              _vm.formatMessage({
                                id: "5g.message.h5.tipmsg.msg1",
                                defaultMessage:
                                  "您的浏览器不支持 HTML5 video 标签"
                              })
                            ) + "\n      "
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  RegExp(/audio\/*/).test(content.mediaContentType)
                    ? _c(
                        "video",
                        {
                          class: _vm.getImageClass(content),
                          style: {
                            height: content.mediaHeight,
                            objectFit: "contain"
                          },
                          attrs: { controls: "", poster: content.thumbnailUrl }
                        },
                        [
                          _c("source", {
                            attrs: {
                              src: content.mediaUrl,
                              type: content.mediaContentType
                            }
                          }),
                          _vm._v(
                            _vm._s(
                              _vm.formatMessage({
                                id: "5g.message.h5.tipmsg.msg1",
                                defaultMessage:
                                  "您的浏览器不支持 HTML5 video 标签"
                              })
                            ) + "\n      "
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "rcs-content-con" },
                    [
                      content.title
                        ? _c(
                            "div",
                            { staticClass: "rcs-title", style: _vm.titleStyle },
                            [_vm._v(_vm._s(content.title))]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      content.description
                        ? _c(
                            "div",
                            {
                              staticClass: "rcs-description",
                              style: _vm.descriptionStyle
                            },
                            [_vm._v(_vm._s(content.description))]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._l(content.links, function(link) {
                        return [
                          link.reply
                            ? _c(
                                "a",
                                {
                                  staticClass: "rcs-link",
                                  style: _vm.linksStyle,
                                  on: {
                                    click: function($event) {
                                      return _vm.handleLinkClick(link)
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(link.reply.displayText))]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          link.action
                            ? _c(
                                "a",
                                {
                                  staticClass: "rcs-link",
                                  style: _vm.linksStyle,
                                  on: {
                                    click: function($event) {
                                      return _vm.handleLinkClick(link)
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(link.action.displayText))]
                              )
                            : _vm._e()
                        ]
                      })
                    ],
                    2
                  )
                ]
              )
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.text && _vm.location
        ? [
            _vm.location.longitude
              ? _c(
                  "div",
                  { staticClass: "mapCon" },
                  [
                    _c("MapItem", {
                      attrs: {
                        uniqueKey: _vm.createTime + "map",
                        latitude: _vm.location.latitude,
                        longitude: _vm.location.longitude,
                        address: _vm.location.address
                      }
                    })
                  ],
                  1
                )
              : _c("div", { staticClass: "text-tpl" }, [
                  _vm._v(_vm._s(_vm.text))
                ])
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.file
        ? [
            RegExp(/image\/*/).test(_vm.file.fileType)
              ? _c("img", {
                  staticClass: "rcs-radius-image",
                  attrs: { src: _vm.file.fileUrl }
                })
              : _vm._e(),
            _vm._v(" "),
            RegExp(/video\/*/).test(_vm.file.fileType)
              ? _c(
                  "video",
                  {
                    staticClass: "rcs-radius-image",
                    attrs: { controls: "", poster: _vm.file.thumbnailUrl }
                  },
                  [
                    _c("source", {
                      attrs: { src: _vm.file.fileUrl, type: _vm.file.fileType }
                    }),
                    _vm._v(
                      _vm._s(
                        _vm.formatMessage({
                          id: "5g.message.h5.tipmsg.msg1",
                          defaultMessage: "您的浏览器不支持 HTML5 video 标签"
                        })
                      )
                    )
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            RegExp(/audio\/*/).test(_vm.file.fileType)
              ? _c(
                  "video",
                  {
                    staticClass: "rcs-radius-image",
                    attrs: { controls: "", poster: _vm.file.thumbnailUrl }
                  },
                  [
                    _c("source", {
                      attrs: { src: _vm.file.fileUrl, type: _vm.file.fileType }
                    }),
                    _vm._v(
                      _vm._s(
                        _vm.formatMessage({
                          id: "5g.message.h5.tipmsg.msg1",
                          defaultMessage: "您的浏览器不支持 HTML5 video 标签"
                        })
                      )
                    )
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            RegExp(/application\/*/).test(_vm.file.fileType)
              ? _c("div", { staticClass: "rcs-file" }, [
                  _vm.file.thumbnailUrl
                    ? _c("img", {
                        staticClass: "thumbnailImage",
                        attrs: { src: _vm.file.thumbnailUrl }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "fileLink",
                      attrs: {
                        href: _vm.file.fileUrl,
                        download: _vm.file.fileName
                      }
                    },
                    [_vm._v(_vm._s(_vm.file.fileName))]
                  )
                ])
              : _vm._e()
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.showBtn
        ? _c(
            "div",
            { staticClass: "rcs-button" },
            _vm._l(_vm.buttons, function(btn) {
              return _c(
                "div",
                [
                  btn.reply
                    ? _c(
                        "el-button",
                        {
                          staticClass: "button-suggestion",
                          attrs: { type: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.handleLinkClick(btn)
                            }
                          }
                        },
                        [_vm._v(_vm._s(btn.reply.displayText))]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  btn.action
                    ? _c(
                        "el-button",
                        {
                          staticClass: "button-suggestion",
                          attrs: { type: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.handleLinkClick(btn)
                            }
                          }
                        },
                        [_vm._v(_vm._s(btn.action.displayText))]
                      )
                    : _vm._e()
                ],
                1
              )
            }),
            0
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-35dcc446", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35dcc446","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/chatRoom/templateCard.vue
// module id = null
// module chunks = 